import React from 'react';
import {Route, Switch} from 'react-router';
import {BrowserRouter} from 'react-router-dom';
import Main from './pages/Main';
import News from "./pages/News";
import NewsDetails from "./pages/NewsDetails";
import NotFound from "./pages/NotFound";
import Competition from "./pages/Competition";
import Team from "./pages/Team";
import AdminPanel from "./pages/AdminPanel";
import LoginPage from "./pages/LoginPage";

const App = () => {

    return (
        <BrowserRouter>
            <Switch>
                <Route exact path={'/'} component={Main}/>
                <Route exact path={'/news'} component={News}/>
                <Route exact path={'/news/:id'} component={NewsDetails}/>
                <Route exact path={'/competition'} component={Competition}/>
                <Route exact path={'/team'} component={Team}/>
                <Route exact path={'/admin-access/login'} component={LoginPage}/>
                <Route exact path={'/admin-access/panel'} component={AdminPanel}/>
                <Route exact path={'*'} component={NotFound}/>
            </Switch>
        </BrowserRouter>
    );
}


export default App;
